<template>

<h1>9</h1>

</template>

<script>
export default {
  name: "Button9",


  data() {
    return    {


    }
  },

  methods : {

  }
}
</script>

<style scoped>



</style>
